import { useClinicData } from "./clinicHooks";

export function useCommonClinicAnalyticsParams(params: Record<any, any> = {}) {
  const { clinic: clinicId, name: clinicName } = useClinicData();
  return {
    ...(params || {}),
    clinicId,
    clinicName,
  };
}
